/**
 * 认证工具函数
 */
import api from './api';

const TOKEN_KEY = 'graph_tutor_token';

// 保存token
export const saveToken = (token) => {
  localStorage.setItem(TOKEN_KEY, token);
  // ✅ 设置到api实例而非全局axios
  api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
};

// 获取token
export const getToken = () => {
  return localStorage.getItem(TOKEN_KEY);
};

// 删除token
export const removeToken = () => {
  localStorage.removeItem(TOKEN_KEY);
  // ✅ 从api实例删除
  delete api.defaults.headers.common['Authorization'];
};

// 检查是否已登录
export const isAuthenticated = () => {
  return !!getToken();
};

// 获取认证头
export const getAuthHeader = () => {
  const token = getToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};

// 登出
export const logout = () => {
  removeToken();
  window.location.href = '/login';
};
